export default "__VITE_ASSET__BpjvcF2p__"